/* eslint-disable @typescript-eslint/unbound-method */
import { Component } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ActivatedRoute, Router } from '@angular/router';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
import { CommonModule } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { FormBuilder, FormControl, type FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { GsIconListComponent } from '../../shared/components/gs-icon-list/gs-icon-list.component';
import { GSIconListBulletModel, GSIconListModel } from '../../shared/components/gs-icon-list/gs-icon-list.model';
import { catchError, map, throwError, type Observable } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
import { StorageEnum } from '../../shared/enums/storage.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AuthService } from '../../shared/services/auth.service';
import { emailValidator } from '../../shared/validators/email.validator';
import { Nav } from '../../shared/enums/nav.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';

@Component({
  selector: 'app-forgot-password',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GsIconListComponent,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    NotificationComponent,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  pageLabels$!: Observable<any>;
  fupForm!: FormGroup;
  apiErrors: any[] = [];
  apiError: string = '';
  formErrorMessage: string = '';
  submitSuccess = false;
  showPasswordLinkExpiredHeader = false;
  pageName = 'Forgot Password';

  constructor(
    private readonly auth: AuthService,
    private readonly cms: CmsService,
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly storage: StorageService,
    private readonly utils: UtilService,
    private readonly route: ActivatedRoute,
    private readonly seoS: SeoService,
    private readonly notifi: NotificationsService,
  ) {}

  ngOnInit(): void {
    this.pageLabels$ = this.cms.getContent('forgot-username-password', 'Forgot').pipe(
      map((data: any) => {
        const unmappedListData = data.bulletList.value.data;
        const listData = new GSIconListModel();
        listData.Header = unmappedListData.header;
        listData.Subheader = unmappedListData.subheader;

        const bulletList: GSIconListBulletModel[] = [];
        unmappedListData?.bulletList?.forEach((bullet: any) => {
          const bulletObj = new GSIconListBulletModel();
          bulletObj.BulletText = bullet.bullet.bulletText;
          bulletObj.BulletTitle = bullet.bullet.bulletTitle;
          bulletObj.IconPath = bullet.bullet.iconPath;
          bulletObj.IconAltText = bullet.bullet.iconAltText;
          bulletObj.ShowBullet = bullet.bullet.showBullet;

          bulletList.push(bulletObj);
        });

        listData.BulletList = bulletList;

        const newDataObj = JSON.parse(JSON.stringify(data));
        newDataObj.accountBenefitsList = listData;

        this.seoS.setSeoTags(data.seo);

        return newDataObj;
      }),
    );

    if (this.checkForPasswordLinkExpired()) {
      this.showPasswordLinkExpiredHeader = true;
    }

    this.fupForm = this.formBuilder.group({
      email: ['', [Validators.required, emailValidator()]],
    });
    this.utils.hideSpinner();
  }

  get email(): FormControl {
    return this.fupForm.get('email') as FormControl;
  }

  onSubmit(): void {
    this.apiError = '';
    this.formErrorMessage = '';
    if (this.fupForm.valid) {
      this.utils.showSpinner();
      this.apiErrors = this.storage.getSession(StorageEnum.GlobalVars).apiErrors;
      // Handle form submission
      this.auth
        .forgotUsernamePassword(this.email.value)
        .pipe(
          catchError((dataError: any) => {
            const errorCode = dataError.error.ErrorCode;
            const newApiError = this.apiErrors.find((error) => {
              return error.apiError.errorCode === errorCode;
            });

            if (newApiError === undefined) {
              const genericApiError = this.apiErrors.find((error) => {
                return error.apiError.errorCode === 'forgotUsernamePasswordError';
              });
              this.showAPIErrorLabel(genericApiError.apiError.displayMessage);
            } else {
              this.showAPIErrorLabel(newApiError.apiError.displayMessage);
            }
            // eslint-disable-next-line @typescript-eslint/no-throw-literal
            this.utils.hideSpinner();
            return throwError(() => new Error(dataError));
          }),
        )
        .subscribe((data: any) => {
          this.utils.consoleGroup('fup submit data: ', data);
          if (data.userInfo.emailId) {
            this.submitSuccess = true;
          } else {
            // what do if empty for some reason?
            // TODO: show ugly err page
          }
          this.utils.hideSpinner();
        });
    } else {
      // Mark all controls as touched to trigger validation messages
      this.fupForm.markAllAsTouched();
      this.showFormErrorLabel();
    }
  }

  replaceEmail(emailMsg: string, email: string): string {
    return emailMsg.replace('{EMAIL}', email.trim());
  }

  logDebug(data: any): void {
    this.utils.consoleGroup('Login icon-list Debug Data', data);
  }

  async goToLogin(): Promise<void> {
    await this.router.navigateByUrl(Nav.Login);
  }

  showFormErrorLabel(): void {
    this.formErrorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
    if (this.formErrorMessage !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }

  showAPIErrorLabel(errMsg: string): void {
    this.apiError = errMsg;
    if (!this.utils.isNullOrUndefined(this.apiError) && this.apiError !== '' && this.apiError) {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.apiError, NotificationType.Error, this.pageName);
    }
  }

  checkForPasswordLinkExpired(): boolean {
    const queryParams = this.route.snapshot.queryParams;
    const passwordLinkExpired = queryParams['passwordLinkExpired'];
    if (this.utils.isNullOrUndefined(passwordLinkExpired)) {
      return false;
    }
    if (passwordLinkExpired === 'true') {
      return true;
    }
    return false;
  }
}
